module.exports = __webpack_public_path__ + "img/76200.a8a6cf85.jpg";